var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({attrs:{"value":_vm.modelValue,"loading":_vm.loading,"items":_vm.data,"item-value":"id","item-text":"name"},on:{"change":function($event){return _vm.$emit('input', $event)},"focus":function($event){return _vm.refresh()}}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }